// 正式项目管理
export default [
  {
    path: '/personnelMatters',
    name: 'personnelMatters',
    meta: { title: '人事管理' },
    component: () => import('../views/personnelMatters/index'),
    children: [
      {
        path: '/personnelMatters/employee',
        name: 'employee',
        meta: { title: '员工资料', isMenu: true },
        component: () => import('../views/personnelMatters/employee'),
      },
      {
        path: '/personnelMatters/department',
        name: 'department',
        meta: { title: '部门管理', isMenu: true },
        component: () => import('../views/personnelMatters/department'),
      },
      {
        path: '/personnelMatters/position',
        name: 'position',
        meta: { title: '职位管理', isMenu: true },
        component: () => import('../views/personnelMatters/position'),
      },
    ],
  },
];
